import { useState } from 'react';
import { forceReloadBull } from '../../../api/index.js';
import QueueStatus from './QueueStatus.js';

const BullManager = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const reloadBull = async () => {
    if (!window.confirm("Êtes-vous sûr de vouloir recharger les scripts Bull et la queue ?")) {
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await forceReloadBull();
      setSuccess(response.data.message);
    } catch (err) {
      setError('Erreur lors du rechargement de Bull.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h3>Forcer la suppression des clefs bull dans Redis</h3>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {success && <p style={{ color: 'green' }}>{success}</p>}

      <button onClick={reloadBull} disabled={loading}>
        {loading ? 'Rechargement en cours...' : 'Recharger Bull (suppr. clefs)'}
      </button>
      <QueueStatus/>
    </div>
  );
};

export default BullManager;
